import { jsx as _jsx } from "react/jsx-runtime";
import { HtmlInclude } from '../common/html-include/HtmlInclude';
import { useProductListerContext } from './context/ProductListerContext';
export const ProductListerSEOText = () => {
    const { seoTextInclude } = useProductListerContext();
    if (!seoTextInclude || seoTextInclude.trim().length < 1) {
        return null;
    }
    return _jsx(HtmlInclude, { htmlFragment: seoTextInclude });
};
